import { useState } from "react";
import { useApiChurchs } from "../../../../../services/hooks/useApiChurchs";
import { useApiRegisters } from "../../../../../services/hooks/useApiRegister";
import { useFormik } from "formik";
import { FormSchema } from "../../../../../helpers/valid";
import { usePaymentContext } from "../../../../../context/paymentContext";

export function useFormRegister() {
  const { dataChurch, isLoadingDataChurch, error } = useApiChurchs();
  const { sendPreRegister, isLoadingPreRegister } = useApiRegisters();
  const [isShepherd, setIsShepherd] = useState(false);

  const { handleSetDataClient } = usePaymentContext();

  // Log para debug
  console.log("useFormRegister - dataChurch:", dataChurch);
  console.log("useFormRegister - error:", error);

  const formik = useFormik({
    initialValues: {
      name_client: "",
      email: "",
      phone: "",
      id_church: "",
      formOfpayment: "",
    },
    validationSchema: FormSchema,
    onSubmit: async (values) => {
      console.log("onSubmit - valores do formulário:", values);
      
      values.shepherd = isShepherd ? 1 : 0;
      
      const churchFilter = dataChurch?.find(
        (church) => church.id === values.id_church
      );
      
      console.log("onSubmit - churchFilter encontrado:", churchFilter);
      console.log("onSubmit - dataChurch completo:", dataChurch);

      const clientData = {
        ...values,
        name_church: churchFilter?.name_church || "Congregação não encontrada",
      };

      console.log("onSubmit - clientData final:", clientData);

      // Salvar dados no localStorage para preservar as informações
      localStorage.setItem('clientData', JSON.stringify(clientData));
      console.log("onSubmit - dados salvos no localStorage");
      
      // Configurar dados no contexto
      handleSetDataClient(clientData);
      console.log("onSubmit - dados configurados no contexto");
      
      // Enviar para o backend
      sendPreRegister({ data: values });
    },
  });

  return {
    dataChurch,
    isLoadingDataChurch,
    error,
    formik,
    isShepherd,
    setIsShepherd,
    isLoadingPreRegister,
  };
}
